(function () {
	'use strict';
	angular.module(modules.homeModule)
		.controller('RelatedTaskController', controller);
	controller.$inject = ['$http', '$uibModalInstance', '$uibModal', '$filter', 'pubSub', 'npDialog', 'model'];
	function controller($http, $uibModalInstance, $modal, $filter, pubSub, npDialog, model) {
		var vm = this;
		vm.initialize = initialize;
		vm.activityTaskDocumentsGridSetting = [];
		vm.activityTaskAttachmentGridSetting = [];
		vm.activityTaskProcessesGridSetting = [];
		vm.activityTaskRiskGridSetting = [];
		vm.activityTaskChecklistGridSetting = [];
		vm.activityTaskDeviationGridSeting = [];
		vm.activityTask;
		vm.activityTaskDocuments = [];
		vm.translation = resources;
		vm.cancel = cancel;
		vm.tabSettings = [];
		function initialize() {
			vm.task = angular.copy(model.data);
			getModuleConfig(function (moduleConfig) {
				vm.task.activityTaskDocuments = combineTaskDocumentRelated(vm.task);
				vm.task.activityTaskDocuments.forEach(x => {
					const href = x.type === 1 ? `folder/${x.id}` : `document/${x.id}`;
					x.name = buildAtag(href, x.name, "_blank");
					x.id = buildAtag(href, x.id, "_blank");
				});

				vm.task.activityTaskProcesses = combineTaskProcessRelated(vm.task);
				vm.task.activityTaskProcesses && vm.task.activityTaskProcesses.forEach(x => {
					const href = x.type === 0 ? `process-fe/process-detail/${x.id}` : `process-fe/area/detail/${x.id}`;
					x.name = buildAtag(href, x.name, "_blank");
					x.id = buildAtag(href, x.id, "_blank");
				});
				vm.task.activityTaskCheckLists && vm.task.activityTaskCheckLists.forEach(x => {
					const href = `checklist-fe/implement/add/${x.rootId}/${x.checklistId}`;
					x.checklistName = buildAtag(href, x.checklistName, "_blank");
					x.checklistId = buildAtag(href, x.checklistId, "_blank");
				});

				vm.task.activityTaskDeviations && vm.task.activityTaskDeviations.forEach(x => {
					const href = `${moduleConfig.frontEndDeviationUrl}register/${x.deviationTypeId}/${x.categoryId}`;
					x.categoryName = buildAtag(href, x.categoryName, "_blank");
					x.categoryId = buildAtag(href, x.categoryId, "_blank");
				});

				vm.task.activityTaskRisks && vm.task.activityTaskRisks.forEach(x => {
					const href = `${moduleConfig.backendHandbookUrl}rm/analysis/${x.riskId}`;
					x.analysisName = buildAtag(href, x.analysisName, "_blank");
					x.riskId = buildAtag(href, x.riskId, "_blank");
				});

				vm.task.activityTaskAttachments && vm.task.activityTaskAttachments.forEach(x => {
					const href = `${moduleConfig.backendHandbookUrl}api/file/getActivityAttachment?id=` + x.activityAttachmentId;
					x.title = buildAtag(href, x.title, "_blank");
				});

				vm.dialogHeader = `${resources.L.Common.taskRelatedItem}: ${vm.task.name}`;
				buildTabSettings();
				buildGridsSettings();
            });
		}

		 function getModuleConfig(callback) {
			 $http.get("/api/AnnualCycle/GetModuleConfig").success(function (response) {
				 callback(response);
            });
        }

		function buildAtag(href, value, target) {
			if (target)
				return String.format('<a class="link-item" href="{0}" target="{2}">{1}</a>', href, value, target);
			return String.format('<a class="link-item" href="{0}">{1}</a>', href, value);
		}

		function buildTabSettings() {
			const gridSetting = [
				{
					name: resources.L.Common.attachments,
					href: 'taskAttachments',
					icon: ' fal fa-file-alt',
					hide: vm.task.activityTaskAttachments.length === 0
				},
				{
					name: resources.L.Common.documents,
					description: '',
					href: 'taskDocuments', icon: 'fa fa-paperclip',
					hide: vm.task.activityTaskDocuments.length === 0,
				},
				{
					name: resources.L.Common.risk,
					description: '',
					href: 'taskRisks', icon: 'fa fa-paperclip',
					hide: vm.task.activityTaskRisks.length === 0
				},
				{
					name: resources.L.Common.process,
					description: '',
					href: 'taskProcesses', icon: 'fa fa-paperclip',
					hide: vm.task.activityTaskProcesses.length === 0
				},
				{
					name: resources.L.Common.checklist,
					description: '',
					href: 'taskCheckLists', icon: 'fa fa-paperclip ',
					hide: vm.task.activityTaskCheckLists.length === 0
				},
				{
					name: resources.L.Common.deviation,
					description: '',
					href: 'taskDeviations', icon: 'fa fa-paperclip',
					hide: vm.task.activityTaskDeviations.length === 0
				},
			];
			const item = gridSetting.find(x => !x.hide);
			if (item) {
				item.active = true;
			}
			vm.tabSettings = gridSetting.filter(x => !x.hide).map((x, index) => {
				x.tabIndex = index + 1;
				return x;
			});
		}
		function buildGridsSettings() {
			//Grid task document related
			vm.activityTaskDocumentsGridSetting = [
				{
					id: 'id', name: resources.L.Common.ID, width: 20, coldefault: true
				},
				{
					id: 'name', name: resources.L.Common.name, width: 40, coldefault: true
				},
				{
					id: 'documentPath', name: resources.L.Common.location, width: 40, coldefault: true
				}

			];
			//Grid task process related
			vm.activityTaskProcessesGridSetting = [
				{
					id: 'id', name: resources.L.Common.ID, width: 40, coldefault: true
				},
				{
					id: 'name', name: resources.L.Common.name, width: 60, coldefault: true
				}

			];
			//Grid task risk related
			vm.activityTaskRiskGridSetting = [
				{
					id: 'riskId', name: resources.L.Common.ID, width: 30, coldefault: true
				},
				{
					id: 'analysisName', name: resources.L.Common.name, width: 70, coldefault: true
				}

			];
			//Grid task checklist related
			vm.activityTaskChecklistGridSetting = [
				{
					id: 'checklistId', name: resources.L.Common.ID, width: 50, coldefault: true
				},
				{
					id: 'checklistName', name: resources.L.Common.name, width: 50, coldefault: true
				}

			]
			//Grid task deviation related
			vm.activityTaskDeviationGridSeting = [
				{
					id: 'categoryId', name: resources.L.Common.ID, width: 40, coldefault: true
				},
				{
					id: 'categoryName', name: resources.L.Common.name, width: 60, coldefault: true
				}
			]
			//Grid task attachment related
			vm.activityTaskAttachmentGridSetting = [
				{
					id: 'title', name: resources.L.Common.name, width: 40, coldefault: true,
					style: 'text-italic'
				},
				{
					id: 'extension', name: resources.L.Common.extension, width: 30, coldefault: true,
					style: 'text-italic'
				},
				{
					id: 'description', name: resources.L.Common.description, width: 30, coldefault: true,
					style: 'text-italic'
				}
			]
		}
		function combineTaskProcessRelated(task) {
			task.activityTaskProcesses && task.activityTaskProcesses.forEach(x => {
				x.id = x.processNumber;
				x.name = x.processName;
				x.type = 0;
			});
			task.activityTaskProcessesAreas && task.activityTaskProcessesAreas.forEach(x => {
				x.id = x.processAreaId;
				x.name = x.processAreaName;
				x.type = 1;
			});
			return [...vm.task.activityTaskProcesses, ...vm.task.activityTaskProcessesAreas];
		}
		function combineTaskDocumentRelated(task) {
			task.activityTaskDocuments && task.activityTaskDocuments.forEach(x => {
				x.id = x.documentId;
				x.name = x.documentName;
				x.type = 0;
			});
			task.activityTaskFolders && task.activityTaskFolders.forEach(x => {
				x.id = x.folderId;
				x.name = x.folderName;
				x.type = 1;
			});
			return [...task.activityTaskDocuments, ...task.activityTaskFolders];
		}
		function cancel() {
			$uibModalInstance.dismiss('cancel');
		}
	}
})();